import type { JSX } from 'react'

import * as era from '~/core/era'
import { ui } from '~/core/skin'

export * as model from './model'

// skin
const skin = era.skin('shared/ui/components/Footer')

Footer.displayName = 'Footer'
export function Footer(): JSX.Element | null {
  return <ui.RenderSkin from={skin} name='footer' key='footer' />
}
